const { getElement } = window.BAO.Utils
class PushProductOption extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['radio']
  }

  static get requiredAttributes () {
    return ['data-option-handle']
  }

  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  setupListeners () {
    super.setupListeners()

    if (this.els.radio?.exists) {
      this.els.radio.elements.forEach((radioEl) => {
        this.listeners.add(radioEl, 'change', this.handleChange.bind(this))
      })
    }
  }

  handleChange (event) {
    if (!this.externalValueEl || !event.target.value) return

    this.externalValueEl.textContent = event.target.value
  }

  get externalValueEl () {
    if (!this.externalEls?.value?.selector) return

    return getElement(
      `${this.externalEls.value.selector}[data-option-handle="${this.dataset?.optionHandle}"]`,
    )
  }
}
if (!customElements.get('push-product-option')) {
  customElements.define('push-product-option', PushProductOption)
}
